import { createApi } from '@reduxjs/toolkit/query/react';

import { apiClientFormOptions } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { Lookup } from '~lookups/models';

export const clientFormOptionsApi = createApi({
  reducerPath: 'clientFormOptionsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiClientFormOptions }),
  tagTypes: ['client-form-options'],
  endpoints: (builder) => ({
    getClientFormOptions: builder.query<Lookup[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'client-form-options', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Lookup[]>(payload),
    }),
  }),
});

export const { useGetClientFormOptionsQuery } = clientFormOptionsApi;
